import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { viewBox: "0 0 973 845" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "m486.341 151.484 196.342 210.935-.002 285.386-196.336 196.336-.173-.172-.172.172-196-196-.001-285.722 196.342-210.935Zm-54.443-77.382 42.152 42.152L257 349.438v265.704L128.204 486.345l.172-.173-54.274-54.274c-98.803-98.803-98.803-258.993 0-357.796s258.993-98.803 357.796 0Zm466.345 0c98.803 98.803 98.803 258.993 0 357.796l-54.274 54.274.172.173-128.46 128.46V349.438L498.47 116.079l41.978-41.977c98.803-98.803 258.994-98.803 357.796 0Z"
    }, null, -1)
  ])))
}
export default { render: render }